<div class="col-xl doc-view-wrap" *ngIf="employeeId && docType">
    <div class="employee-breadcrumb mb-3 no-print">
        <span class="current">Documentación de contratación</span>
    </div>

    <div class="d-flex align-items-center justify-content-between mb-4 flex-wrap gap-3 no-print">
        <div class="d-flex align-items-center gap-3">
            <button type="button" class="employee-back-btn" (click)="goBack()" title="Regresar">
                <i class="ti ti-arrow-left"></i>
            </button>
            <h4 class="mb-0">{{docTypeMeta?.label || 'Documento'}}</h4>
        </div>
        <button type="button" class="doc-view-print-btn" (click)="print()" *ngIf="document">
            <i class="ti ti-printer"></i> Imprimir
        </button>
    </div>

    <div class="doc-view-panel">
        <div *ngIf="!loading && !document" class="doc-view-empty">
            Documento no encontrado.
        </div>

        <ng-container *ngIf="document">
            <img *ngIf="isImage" [src]="documentUrl" [alt]="docTypeMeta?.label" class="doc-view-image">
            <iframe *ngIf="isPdf" [src]="safePdfUrl" class="doc-view-pdf"></iframe>
        </ng-container>
    </div>
</div>
